var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "simple-row" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "a",
            {
              staticClass: "swb-btn swb-btn-small",
              on: { click: _vm.toPrint }
            },
            [_vm._v("打印")]
          ),
          _vm._v(" "),
          _vm.checkActionPerm("audit", _vm.settleProof.auditorPostId) &&
          _vm.settleProof.settleChannelId == -1 &&
          !_vm.settleProof.invalid &&
          _vm.settleProof.applyState == _vm.applyStateApplied &&
          _vm.settleProof.auditState == _vm.auditStateInitial
            ? _c(
                "a",
                {
                  staticClass: "swb-btn swb-btn-small",
                  on: { click: _vm.doAudit }
                },
                [_vm._v("审核")]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("结算单信息")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showSettleInfoFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowSettleInfo()
              }
            }
          },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.showSettleInfoFlag ? "隐藏" : "展开"))
            ]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showSettleInfoFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showSettleInfoFlag
        ? [
            _c("div", { staticClass: "simple-form flex col-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.settleProof.innerNo || ""))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.settleProof.reservedNo || ""))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.settleProof.auditPoofNo || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.settleProof.sellerRealComName))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.settleProof.sellerRealComCode))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.settleProof.buyerInnerSellerCode))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(6),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.settleBizTypeMap[_vm.settleProof.bizType])
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("div", { staticClass: "form-value " }, [
                  _vm.settleProof.invalid
                    ? _c("span", { staticClass: "font-red" }, [
                        _vm._v("已作废")
                      ])
                    : _c("span", [
                        _vm._v(_vm._s(_vm.settleProof.proofStateText))
                      ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(_vm.settleProof.bizType == 1 ? "购置" : "服务") +
                        "含税金额(元)"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value " }, [
                  _c("span", [
                    _vm._v(
                      _vm._s((_vm.settleProof.settleAmount || 0).toFixed(2))
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(_vm.settleProof.bizType == 1 ? "购置" : "服务") +
                        "未税金额(元)"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value " }, [
                  _c("span", [
                    _vm._v(
                      _vm._s((_vm.settleProof.settleNtxAmount || 0).toFixed(2))
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(_vm.settleProof.bizType == 1 ? "购置" : "服务") +
                        "税额(元)"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value " }, [
                  _c("span", [
                    _vm._v(_vm._s((_vm.settleProof.taxAmount || 0).toFixed(2)))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(8),
                _vm._v(" "),
                _c("div", { staticClass: "form-value " }, [
                  _c("span", [
                    _vm._v(
                      _vm._s((_vm.settleProof.invoiceAmount || 0).toFixed(2))
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(9),
                _vm._v(" "),
                _c("div", { staticClass: "form-value " }, [
                  _c("span", [
                    _vm._v(
                      _vm._s((_vm.settleProof.invoiceNtxAmount || 0).toFixed(2))
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(10),
                _vm._v(" "),
                _c("div", { staticClass: "form-value " }, [
                  _c("span", [
                    _vm._v(
                      _vm._s((_vm.settleProof.invoiceTaxAmount || 0).toFixed(2))
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(11),
                _vm._v(" "),
                _c("div", { staticClass: "form-value " }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        (
                          (_vm.settleProof.settleAmount || 0) -
                          (_vm.settleProof.invoiceAmount || 0)
                        ).toFixed(2)
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(12),
                _vm._v(" "),
                _c("div", { staticClass: "form-value " }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        (
                          (_vm.settleProof.settleNtxAmount || 0) -
                          (_vm.settleProof.invoiceNtxAmount || 0)
                        ).toFixed(2)
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(13),
                _vm._v(" "),
                _c("div", { staticClass: "form-value " }, [
                  _c("span", [
                    _vm._v(
                      _vm._s((_vm.settleProof.taxDiffAmount || 0).toFixed(2))
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(14),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.settleProof.paymentAmount == _vm.settleProof.settleAmount
                    ? _c("span", [_vm._v('"')])
                    : _vm.settleProof.paymentAmount == 0
                    ? _c("span", [_vm._v("待付款")])
                    : _c("span", [_vm._v("部分付款")])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(15),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.settleProof.paymentAmount == _vm.settleProof.settleAmount
                    ? _c("span")
                    : _vm.settleProof.paymentAmount == 0
                    ? _c("span")
                    : _c("span", [
                        _vm._v(
                          _vm._s(
                            Math.floor(
                              (_vm.settleProof.paymentAmount /
                                _vm.settleProof.settleAmount) *
                                100
                            )
                          )
                        )
                      ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _vm._m(16),
                _vm._v(" "),
                _c("div", { staticClass: "form-value " }, [
                  _c("span", [_vm._v(_vm._s(_vm.settleProof.applyDesc || ""))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(17),
                _vm._v(" "),
                _c("div", { staticClass: "form-value " }, [
                  _c("span", [_vm._v(_vm._s(_vm.settleProof.memo || ""))])
                ])
              ]),
              _vm._v(" "),
              _vm.settleProof.pullBackNo != null &&
              _vm.settleProof.pullBackNo != ""
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(18),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _vm.settleProof.pulledBack
                        ? _c("span", [_vm._v("是")])
                        : _c("span", [_vm._v("否")])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.settleProof.pullBackNo != null &&
              _vm.settleProof.pullBackNo != ""
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(19),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.settleProof.rejectCause || ""))
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.settleProof.pullBackNo != null &&
              _vm.settleProof.pullBackNo != ""
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(20),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.settleProof.pullBackNo || ""))
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.settleProof.jointInvokeDone &&
              _vm.settleProof.jointInvokeErrMsg != null
                ? _c("div", { staticClass: "form-group" }, [
                    _vm._m(21),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.settleProof.jointInvokeErrMsg || ""))
                      ])
                    ])
                  ])
                : _vm._e()
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("发票")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showInvoiceFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowInvoice()
              }
            }
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.showInvoiceFlag ? "隐藏" : "展开"))]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showInvoiceFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showInvoiceFlag
        ? _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.settleProof.settleInvoiceItemList,
                border: "",
                maxHeight: "400"
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "actualNo",
                  label: "发票号",
                  fixed: "",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "actualCode",
                  label: "发票代码",
                  fixed: "",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "buyerTaxPayerNo",
                  label: "纳税人识别号",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  width: "150",
                  prop: "actualAmount",
                  label: "含税金额(元)",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s((scope.row.actualAmount || 0).toFixed(2))
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  width: "150",
                  prop: "actualNtxAmount",
                  label: "未税金额(元)",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s((scope.row.actualNtxAmount || 0).toFixed(2))
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  width: "150",
                  prop: "actualTaxAmount",
                  label: "税额(元)"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s((scope.row.actualTaxAmount || 0).toFixed(2))
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "160",
                  prop: "actualDate",
                  label: "发票日期"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "操作",
                  width: "100",
                  fixed: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "a",
                          {
                            staticClass: "swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.viewInvoiceFile(scope.row)
                              }
                            }
                          },
                          [_vm._v("查看附件")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.settleProof.bizType == 1
        ? _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("商品列表")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "shrink-tab fr",
                class: _vm.showGoodsFlag ? "current" : "",
                on: {
                  click: function($event) {
                    _vm.doShowGoods()
                  }
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.showGoodsFlag ? "隐藏" : "展开"))
                ]),
                _vm._v(" "),
                _c("i", {
                  class: _vm.showGoodsFlag
                    ? "el-icon-arrow-down"
                    : "el-icon-arrow-right"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.settleProof.bizType == 1 && _vm.showGoodsFlag
        ? _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.settleProof.settleBizSrcList,
                border: "",
                maxHeight: "400"
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "bizVoucherInnerNo",
                  fixed: "",
                  label: "验收单号",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "a",
                          {
                            ref: "#",
                            staticClass: "table-cell-link",
                            on: {
                              click: function($event) {
                                _vm.toPurchReceipt(scope.row)
                              }
                            }
                          },
                          [_vm._v(_vm._s(scope.row.bizVoucherInnerNo))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  width: "120",
                  prop: "buyerCostCenterCode",
                  label: "成本中心"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  width: "200",
                  prop: "bizUnitName",
                  label: "门店名称",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  width: "100",
                  prop: "amount",
                  label: "含税金额(元)"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s((scope.row.amount || 0).toFixed(2)))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  width: "100",
                  prop: "ntxAmount",
                  label: "未税金额(元)"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (scope.row.amount - scope.row.taxAmount).toFixed(
                                2
                              )
                            )
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "cgVoucherNo",
                  label: "购置单号",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.cgVoucherNo != null
                          ? _c("span", [
                              _c(
                                "a",
                                {
                                  ref: "#",
                                  staticClass: "table-cell-link",
                                  on: {
                                    click: function($event) {
                                      _vm.toRequireVoucher(rows.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(rows.row.cgVoucherNo))]
                              )
                            ])
                          : _c("span", [_vm._v("——")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  width: "100",
                  prop: "quantity",
                  label: "数量"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "160",
                  prop: "checkTime",
                  label: "验收时间"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "contractNo",
                  label: "合同编号",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _vm.settleProof.contractNo != null
                          ? _c("span", [
                              _c(
                                "a",
                                {
                                  ref: "#",
                                  staticClass: "table-cell-link",
                                  on: {
                                    click: function($event) {
                                      _vm.toContract(rows.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.settleProof.contractNo))]
                              )
                            ])
                          : _c("span", [_vm._v("——")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "200",
                  label: "操作",
                  fixed: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "a",
                          {
                            staticClass: "swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.viewPurchReceipt(scope.row)
                              }
                            }
                          },
                          [_vm._v("验收详情")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.settleProof.bizType == 2
        ? _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("验收单列表")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "shrink-tab fr",
                class: _vm.showServWorkFlag ? "current" : "",
                on: {
                  click: function($event) {
                    _vm.doShowServWork()
                  }
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.showServWorkFlag ? "隐藏" : "展开"))
                ]),
                _vm._v(" "),
                _c("i", {
                  class: _vm.showServWorkFlag
                    ? "el-icon-arrow-down"
                    : "el-icon-arrow-right"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.settleProof.bizType == 2 && _vm.showServWorkFlag
        ? _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.settleProof.settleBizSrcList,
                border: "",
                maxHeight: "400"
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "contractNo",
                  fixed: "",
                  label: "合同编号",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _vm.settleProof.contractNo != null
                          ? _c("span", [
                              _c(
                                "a",
                                {
                                  ref: "#",
                                  staticClass: "table-cell-link",
                                  on: {
                                    click: function($event) {
                                      _vm.toContract(rows.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.settleProof.contractNo))]
                              )
                            ])
                          : _c("span", [_vm._v("——")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "bizVoucherInnerNo",
                  fixed: "",
                  label: "验收单号",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "a",
                          {
                            ref: "#",
                            staticClass: "table-cell-link",
                            on: {
                              click: function($event) {
                                _vm.toServcWorkReceipt(scope.row)
                              }
                            }
                          },
                          [_vm._v(_vm._s(scope.row.bizVoucherInnerNo))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  width: "120",
                  prop: "buyerCostCenterCode",
                  label: "成本中心"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  width: "200",
                  prop: "bizUnitName",
                  label: "门店名称",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "160",
                  prop: "checkTime",
                  label: "验收时间"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  width: "100",
                  prop: "amount",
                  label: "含税价(元)"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s((scope.row.amount || 0).toFixed(2)))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  width: "100",
                  prop: "ntxAmount",
                  label: "未税价(元)"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (scope.row.amount - scope.row.taxAmount).toFixed(
                                2
                              )
                            )
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "buyerBizTag",
                  label: "结算标签",
                  width: "100",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return _vm._l(scope.row.buyerBizTag.split("|"), function(
                        tagId
                      ) {
                        return scope.row.buyerBizTag != null &&
                          scope.row.buyerBizTag != ""
                          ? _c("div", [
                              tagId != null &&
                              tagId != "" &&
                              _vm.getBizTagNameById(tagId) != null
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "swb-tags swb-tags-success mr5"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getBizTagNameById(tagId))
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e()
                      })
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "100",
                  prop: "settleFree",
                  label: "无需结算"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.settleFree ? "是" : "否"))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { align: "center", width: "100", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "a",
                          {
                            staticClass: "swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.toSetBuyerBizTag($event, scope.row)
                              }
                            }
                          },
                          [_vm._v("设置标签")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      (_vm.settleProof.contractId != -1 && _vm.contractPhasedPaymentAllowed) ||
      (_vm.settleProof.contractId == -1 && _vm.phasedPaymentAllowed)
        ? [
            _c("div", { staticClass: "content-caption dashed" }, [
              _c("span", [_vm._v("付款阶段")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "shrink-tab fr",
                  class: _vm.showPayPhasesFlag ? "current" : "",
                  on: {
                    click: function($event) {
                      _vm.doShowPayPhases()
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.showPayPhasesFlag ? "隐藏" : "展开"))
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    class: _vm.showPayPhasesFlag
                      ? "el-icon-arrow-down"
                      : "el-icon-arrow-right"
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm.showPayPhasesFlag
              ? _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    attrs: {
                      data: _vm.settleProof.settlePayPhaseList,
                      border: "",
                      "span-method": _vm.arraySpanMethod
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "phaseName",
                        label: "阶段名称",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "phaseType",
                        label: "阶段类型",
                        width: "150",
                        "show-overflow-tooltip": ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.payPhaseTypeMap[rows.row.phaseType]
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "acntPeriodStartDate",
                        label: "账期起算日",
                        width: "150",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _vm.settleProof.acntPeriodForm == 1
                      ? _c("el-table-column", {
                          attrs: {
                            align: "right",
                            prop: "acntPeriodDays",
                            width: "150",
                            label: "账期"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.settleProof.acntPeriodForm == 2
                      ? _c("el-table-column", {
                          attrs: {
                            align: "right",
                            prop: "phaseGapDays",
                            width: "150",
                            label: "当前阶段间隔天数"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "calcBasis",
                        label: "金额计算依据",
                        width: "150",
                        "show-overflow-tooltip": ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.amtCalcMethodMap[rows.row.calcBasis]
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "ratio",
                        label: "付款比例(%)",
                        width: "150",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "amount",
                        label: "付款金额",
                        width: "150",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "payMethod",
                        width: "150",
                        label: "付款方式"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.payMethodMap[rows.row.payMethod])
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("结算付款项")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showPayInfoFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowPayInfo()
              }
            }
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.showPayInfoFlag ? "隐藏" : "展开"))]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showPayInfoFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showPayInfoFlag
        ? _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.settleProof.settlePayItemList,
                border: "",
                maxHeight: "400"
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "180",
                  fixed: "",
                  prop: "payVoucherNo",
                  label: "付款单号",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.payVoucherNo != null
                          ? _c("span", [
                              _c(
                                "a",
                                {
                                  ref: "#",
                                  staticClass: "table-cell-link",
                                  on: {
                                    click: function($event) {
                                      _vm.toPayVoucher(rows.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(rows.row.payVoucherNo))]
                              )
                            ])
                          : _c("span", [_vm._v("——")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "80",
                  prop: "staffLoan",
                  label: "员工借款",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.staffLoan
                          ? _c("span", { staticClass: "font-red" }, [
                              _vm._v("是")
                            ])
                          : _c("span", [_vm._v("否")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "subject",
                  label: "付款主题",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "80",
                  prop: "payWay",
                  label: "付款途径",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.payWayMap[rows.row.payWay]))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  width: "150",
                  prop: "amount",
                  label: "付款金额(元)",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s((rows.row.amount || 0).toFixed(2)))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "100",
                  prop: "auditState",
                  label: "审核状态",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.auditStateMap[rows.row.auditState]))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "90",
                  prop: "payResult",
                  label: "结果状态"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.payResult == 0
                          ? _c("span", [_vm._v("待付款")])
                          : rows.row.payResult == -1
                          ? _c("span", [_vm._v("付款失败")])
                          : _c("span", [_vm._v("付款成功")])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "swb-dt-popover",
        { ref: "popoverRef", attrs: { classes: "popper-tabs" } },
        [
          _c("swb-biz-tag-list-for-select", {
            ref: "swb_biz_tag_list_for_select",
            attrs: { bizAspect: _vm.bizAspect, selectIds: _vm.tagIds },
            on: {
              "notity-bizTag-comfirm": _vm.doBizTagConfirm,
              "notity-bizTag-cancel": _vm.doBizTagCancel
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("结算单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("记账凭证号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("审批单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("供方公司名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("供方公司编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("供方标识")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("业务类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("单据状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发票含税金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发票未税金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发票税额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("差额含税金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("差额未税金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("差额税额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("付款情况")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("付款比例(%)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请描述")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("结算描述")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已冲销")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("冲销原因")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("冲销单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("对接推送失败原因")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f1d9dcca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1d9dcca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/settle/SettleProofDetail.vue
// module id = 2924
// module chunks = 0